// Universal projection constants. Strategies that need a different convention
// (e.g. a product that bills 31-day months) can declare their own and not
// import these.

export const DAYS_IN_MONTH = 30;

// Sentinel pool value for "unlimited" lifetime benefits. A standard (non-
// hybrid) LTC policy with a null/undefined `policyMaximumBenefitAmount` is
// unlimited (see legacy `isUnlimitedBenefit`); we seed the pool at this value
// so payouts are never pool-limited. The client renders any pool >= this as
// "Unlimited" (`policies-comparison/lib/format-utils.ts`). Canonical home is
// here; `calcFundingSourceDerivatives` re-exports it for legacy consumers.
export const unlimitedMaxBenefitMagicNumber = 999999999;

// 2-ADL gating: a US LTC-rider activation rule that almost every product
// follows. ≥ 2 ADLs needed for benefit eligibility; earlyCare clients
// with < 2 ADLs only get credit for half the phase days.
export const POLICY_ACTIVATES_AT_ADL_COUNT = 2;
export const ONE_ADL_DURATION_MULTIPLIER = 0.5;
